"use strict";

// these are the elements that triggered a overlay to open.
// we have to return the focus to them after their overlay is closed again.
let toggleByOverlayId = {};
const startZIndex = 100;
let openModals = [];
let $modalsById = {};

export function init() {
    document.body.addEventListener('click', function (evt) {
        if (openModals && openModals.length) {
            let $target = $(evt.target);
            let $parent = $target.closest('.js-overlay, .js-overlay__toggle, .js-overlay__close, #ui-datepicker-div');

            if (!$target.is('.js-overlay, .js-overlay__toggle, .js-overlay__close') && !$parent.length) {
                openModals.map(id => $('#' + id)).forEach(closeOverlay);
            }
        }
    }, true);
}

export function initInScope ($scope) {
    $('.js-overlay__toggle').on('click', function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();


        let $toggle = $(this);
        let $target = $($toggle.data('target'));
        let $targetCheckbox = $($toggle.data('target') + '-open');

        if (!$toggle.data('target')) {
            console.error('Can\'t show overlay. Attribute data-target is not set for', this);
            return;
        }

        if (!$target || !$target.length) {
            console.error('Can\'t show overlay. Could not find overlay "' + $toggle.data('target') + '" for',
                this);
            return;
        }

        if ($targetCheckbox.length) {
            if($targetCheckbox.is(':checked')){
                $targetCheckbox.prop('checked', false);
            }else{
                $targetCheckbox.prop('checked', 'checked');
            }
        }

        let id = $target.attr('id');
        if (!$target.attr('id')) {
            console.warn('Overlay ', $target[0], 'does not have a id attribute. Please add a unique id.')
        }

        if (!$target.hasClass('is-open')) {
            closeOverlay($('.js-overlay'));
            openOverlay($target, $toggle);
            toggleByOverlayId[id] = $toggle;
        } else {
            closeOverlay($target);
            toggleByOverlayId[id] = null;
        }
    });

    $('.js-overlay__close').on('click', function (evt) {
        let $modal = $(this).closest('.js-overlay');
        $modal.triggerHandler('overlay.cancel');

        if (!$modal || !$modal.length) {
            console.error('Can\'t closed modal. The close button', this, 'is not a children of a .js-overlay');
            return;
        }

        let $targetCheckbox = $('#' + $(this).closest('.js-overlay').attr('id') + '-open');

        if ($targetCheckbox.length) {
            if($targetCheckbox.is(':checked')){
                $targetCheckbox.prop('checked', false);
            }else{
                $targetCheckbox.prop('checked', 'checked');
            }
        }

        closeOverlay($modal);

        if($('#product-filter-overlay-open').length){
            let url = window.location.toString();
            let removeString = '&product-filter-overlay-open=on';
            let newUrl = url.replace(removeString, '');

            window.history.replaceState({}, document.title, newUrl);

            $scope.find('.js-product-grid-quick-filter__text').each(function () {
                if($(this).text() === 'on'){
                    $(this).closest('li').remove();
                }
            })

        }
    });

    $('.js-overlay').each(function () {
        let paramResult = getIdAndElementFromParam($(this));
        if (!paramResult) {return;}

        $modalsById[paramResult.id] = paramResult.$element;
    });
}

export function openOverlay (param, toggle) {
    if(toggle.is('.js-overlay__toggle--cart')){
        $('body').addClass('cart-open');
    }
    let paramResult = getIdAndElementFromParam(param);
    if (!paramResult) {return;}

    openModals.push(paramResult.id);
    handleChange();
}

export function closeOverlay (param) {
    $('body').removeClass('cart-open');
    let paramResult = getIdAndElementFromParam(param);
    if (!paramResult) {return;}

    let id = paramResult.id;

    if (toggleByOverlayId[id]) {
        toggleByOverlayId[id].focus();
        toggleByOverlayId[id] = null;
    }

    openModals.splice(openModals.indexOf(id),1);
    handleChange();
}

function handleChange() {
    let currentZIndex = startZIndex;

    let closedModalIds = Object.keys($modalsById).filter(function (modalId) {
        return openModals.indexOf(modalId) < 0;
    });

    closedModalIds.forEach(function (modalId) {
        let $modal = $modalsById[modalId];

        if ($modal
            && $modal.length
            && $modal.hasClass('is-open')) {
;
            $modal.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function (evt) {
                if (evt.target === $modal[0]) {
                    $modal.triggerHandler('overlay.hidden');
                    $('body').removeClass('overflow-hidden');
                }
            });

            $modal.triggerHandler('overlay.hide');
            $modal.removeClass('is-open').attr('aria-hidden', 'true').css('z-index', '');
        }
    });

    openModals.forEach(function (modalId) {
        let $modal = $modalsById[modalId];

        if ($modal
            && $modal.length
            && !$modal.hasClass('is-open')) {
            $modal.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function animationEndHandler(evt) {
                if (evt.target === $modal[0]) {
                    $modal.triggerHandler('overlay.shown');
                    $('body').addClass('overflow-hidden');
                }
                $modal.off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', animationEndHandler);
            });

            $modal.triggerHandler('overlay.show');
            let defaultZIndex = $modal.css('z-index');
            if (!defaultZIndex || defaultZIndex === 'auto') {
                $modal.css('z-index', currentZIndex++);
            }

            $modal
                .addClass('is-open')
                .attr('aria-hidden', 'false')
                .focus();
        }
    });
}

function getIdAndElementFromParam(param) {
    let id;
    let $modal;
    if (typeof param === "string") {
        id = param;
        $modal = $('#' + id + '.js-overlay');
        if (!$modal || !$modal.length) {
            console.error('Can\'t find overlay with id "' + id + '"', $modal);
            return;
        }
    } else {
        $modal = param;
        id = $modal.attr('id');
        if (!id) {
            console.error('Can\'t use overlay ', $modal, '. The overlay needs a unique id attribute');
            return;
        }
    }

    return {
        id: id,
        $element: $modal
    }
}

export function isOverlay ($element) {
    return $element.is('.js-overlay');
}